import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { lighten, darken } from "@material-ui/core/styles";
import IconHolder from '../../Helpers/IconHolder';
import './BusinessSolutionsPurchasingProcess.scss';

const white = "#ffffff";
const offWhite = "rgba(255, 255, 255, 0.7)";

const useStyles = makeStyles(theme => ({
  stepWrapper: {
    border: `3px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
  },
  background: {
    backgroundColor: "#ffffff",
  },
  white: {
    color: offWhite,
    border: `2px solid ${offWhite}`,
    '&:hover': {
      color: white,
      borderColor: white
    },
    '&:focus': {
      boxShadow: `0 0 5px 0px ${white}`,
      outline: 'none'
    }
  },
  action: {
    height: 36,
    fontSize: "0.875rem",
    fontWeight: 700,
    letterSpacing: "1.4px",
    color: white,
    backgroundColor:  theme.palette.primary.main,
    border: "none",
    boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
    '&:hover': {
      color: white,
      backgroundColor: darken(theme.palette.primary.main, 0.2),
    },
    '&:focus': {
      color: white,
      backgroundColor: lighten(theme.palette.primary.main, 0.2),
      outline: "none"
    }
  },
  actionLight: {
    height: 36,
    fontSize: "0.875rem",
    fontWeight: 700,
    letterSpacing: "1.4px",
    color: theme.palette.primary.main ,
    backgroundColor:  white,
    border: "none",
    boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
    },
    '&:focus': {
      color: white,
      backgroundColor: lighten(theme.palette.primary.main, 0.2),
      outline: "none"
    }
  }
 }));
 
export default function PurchasingProcess(props) {
  const classes = useStyles();

  return (
    <Row className={`business-solutions-purchasing-process justify-content-center ${classes.background}`}>
      <Container fluid="sm" className="mt-5 mb-5">
        <Row>
          <Col md={{ span: 6, order: 1 }} className="content-wrapper">
            <Row className="group-container">
              <div className="image-container">
                <Image src={props.data.stepsCallToAction.image} alt="" />
              </div>
              <div className="content-container">
                <h3>{props.data.stepsCallToAction.title}</h3>
                <p>{props.data.stepsCallToAction.paragraphs}</p>
              </div>
            </Row>
            <Row>
              <Button 
              variant={`${props.isModernized ? "contained" : "outlined" }`} 
              size="large" href={props.data.stepsCallToAction.callToAction.href} onClick={undefined} 
              className={`btn-wide-sm  ${classes.actionLight}`}>{props.data.stepsCallToAction.callToAction.buttonTitle}</Button>
            </Row>
          </Col>
          <Col md={{ span: 6, order: 2 }}>
              <Row>
              <Col className="mx-3">
            <h2 className= "business-solutions-title">{props.data.title}</h2>
                <p>{props.data.subtitle}</p>
              </Col>
            </Row>
            {props.data.steps.map((step, index) =>
            <Row key={index} className="mt-3 px-5">
              <Col xs={1} className="d-flex justify-content-center main-business-solutions">
                <div className={`step-container ${classes.stepWrapper}`}>{index + 1}</div>
              </Col>
              <Col className="d-flex align-items-start justify-content-center flex-column">
                <h3 className="business-solutions-name" >{step.title}</h3>
                {step.paragraphs.map((p, i) => Array.isArray(p) ?
                  buildList(p, i)
                  : <p className='business-solutions-content' key={i}>{p}</p>)
                }
              </Col>
            </Row>
            )}
            <Row className="mt-3 px-4">
              <Button 
                variant={`${props.isModernized ? "contained" : "outlined" }`} 
                size="large" href={props.journeys.termJourney} onClick={undefined} 
                className={`btn-wide-sm  ${classes.action}`}>{props.data.callToAction.buttonTitle}</Button>
            </Row>
          </Col>
        </Row>
      </Container>
    </Row>
  );
}

function buildList(list, index) {
  return (
    <ul key={index}>
      {list.map((listItem, i) => Array.isArray(listItem) ?
        buildList(listItem, i) :
        <li key={i}>{listItem}</li>
      )}
    </ul>
  );
}

PurchasingProcess.propTypes = {
  data: PropTypes.shape({
    subtitle: PropTypes.string,
    stepsfooter: PropTypes.array
  }),
  journeys: PropTypes.object,
}


// WEBPACK FOOTER //
// ./src/components/LandingPages/PurchasingProcess/BusinessSolutionsPurchasingProcess.js